import { saveFilterInheritValues } from '../utils/filterInherit';

import type { IFilterSyncTarget } from '../types';

export const inheritSyncTarget: IFilterSyncTarget = {
  name: 'inherit',
  shouldSync: (context) => {
    return !!context?.pageId;
  },
  /** 保存当前页面声明可继承的字段，供下一页 inheritSource 消费 */
  sync: (values, context) => {
    saveFilterInheritValues(context.pageId, context.items, values, context.dispatch);
  },
};
